import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/cn';

/**
 * Horizontal stack layout component.
 */
const HStack = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(function HStack({
  className,
  ...props
}, ref) {
  return <div ref={ref} className={cn('flex', className)} {...props} />;
});
export default HStack;